(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fermorin-price-sync"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fermorin-price-sync')) {
    customElements.define('fermorin-price-sync', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById('MainProduct-' + this.dataset.section);
        this.config = JSON.parse(this.querySelector('script').textContent);
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.onSeal = (event) => {
          if (event.detail?.element && !this.root.contains(event.detail.element)) return;
          this.sync();
        };
        this.events = ['sealsubs:selling_plan_changed', 'sealsubs:price_update', 'sealsubs:subscription_widget_created'];
        this.events.forEach(name => document.addEventListener(name, this.onSeal));
        this.root.addEventListener('change', this.schedule);
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root, {childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked']});
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.root?.removeEventListener('change', this.schedule);
        this.events?.forEach(name => document.removeEventListener(name, this.onSeal));
      }
      text(element, value) {
        if (element && element.textContent !== value) element.textContent = value;
      }
      money(container, value) {
        if (!container) return;
        const money = container.querySelector('.money');
        if (money) { this.text(money, value); return; }
        const text = Array.from(container.childNodes).find(node => node.nodeType === 3 && node.textContent.trim());
        if (text) { if (text.textContent !== value) text.textContent = value; }
        else container.prepend(document.createTextNode(value));
      }
      sync() {
        const form = document.getElementById('product-form-' + this.dataset.section);
        const variant = this.config.variants[form?.querySelector('[name="id"]')?.value];
        const priceRoot = document.getElementById('price-' + this.dataset.section);
        const main = priceRoot?.querySelector('.price__main__value');
        if (!variant || !main) return;
        const widget = this.root.querySelector('.sealsubs-container');
        const choice = widget?.querySelector('.sls-option:checked');
        const selectedRow = choice?.closest('.sls-option-container');
        let planId = form?.querySelector('[name="selling_plan"]')?.value || '';
        if (choice?.dataset.type === 'one_time') planId = '';
        else if (choice?.dataset.type === 'subscription') planId = selectedRow?.querySelector('[name="subs_interval"]')?.value || planId;
        const plan = variant.plans[planId];
        this.root.querySelectorAll('[data-saving-variant]').forEach(badge => {
          const option = this.config.variants[badge.dataset.savingVariant];
          if (!option) return;
          const optionPrice = option.plans[planId]?.price ?? option.price;
          const percent = option.compare > optionPrice ? Math.floor((option.compare - optionPrice) * 1000 / option.compare) / 10 : 0;
          badge.hidden = percent <= 0;
          this.text(badge, this.config.savingLabel.replace('[percent]', percent));
          badge.title = option.compareMoney + ' → ' + (option.plans[planId]?.money || option.money);
        });
        const discounted = !!plan && plan.price < variant.price;
        const final = plan || variant;
        this.text(main, final.money);
        main.classList.toggle('price__sale', variant.compare > final.price || discounted);
        priceRoot.classList.remove('visibility-hidden');
        let regular = priceRoot.querySelector('.price__regular');
        if (!regular) {
          regular = document.createElement('div');
          regular.className = 'price__regular body2';
          priceRoot.querySelector('.price').prepend(regular);
        }
        regular.hidden = !(variant.compare > final.price);
        this.text(regular, variant.compareMoney);
        let steps = priceRoot.querySelector('.fermorin-price-steps');
        let extra = priceRoot.querySelector('.fermorin-price-extra');
        if (!steps) {
          steps = document.createElement('div');
          steps.className = 'fermorin-price-steps';
          const label = document.createElement('span');
          const amount = document.createElement('s');
          steps.append(label, amount);
          main.parentElement.before(steps);
        }
        if (!extra) {
          extra = document.createElement('div');
          extra.className = 'fermorin-price-extra';
          priceRoot.querySelector('.price').append(extra);
        }
        steps.hidden = extra.hidden = !discounted;
        if (discounted) {
          this.text(steps.querySelector('span'), this.config.oneTimeLabel + ' ');
          this.text(steps.querySelector('s'), variant.money);
          const percent = Math.round((variant.price - plan.price) / variant.price * 100);
          this.text(extra, this.config.extraLabel.replace('[percent]', percent).replace('[amount]', plan.saving));
        }
        widget?.querySelectorAll('.sls-option-container').forEach(row => {
          const rowPlanId = row.querySelector('[name="subs_interval"]')?.value;
          const rowPlan = variant.plans[rowPlanId];
          const value = rowPlan || variant;
          this.money(row.querySelector('.sls-price'), value.money);
          const original = row.querySelector('.sls-original-price');
          if (original) {
            original.hidden = value.price >= variant.price;
            this.money(original, variant.money);
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
